import * as Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import * as React from 'react';
import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';

export default function asyncComponent(importComponent) {
    class AsyncFunc extends React.Component<any,any> {
        public mounted = false;

        constructor(props) {
            super(props);
            Nprogress.configure({showSpinner: false});
            this.state = {
                component: null
            };
        }


        public componentWillMount() {
            Nprogress.start();
        }

        public componentWillUnmount() {
            this.mounted = false;
        }

        public async componentDidMount() {
            this.mounted = true;
            const {default: Component} = await importComponent();
            Nprogress.done();
            if (this.mounted) {
                this.setState({
                    component: <Component {...this.props} />
                });
            }
        }

        public render() {
            const Component = this.state.component || <div/>;
            return (
                <ReactPlaceholder type='text' rows={7} ready={Component !== null}>
                    {Component}
                </ReactPlaceholder>
            );
        }
    }

    return AsyncFunc;
}



// WEBPACK FOOTER //
// ./src/helpers/AsyncFunc.tsx